/**
 * Ambient holder for the admin's currently-active region.
 *
 * The audit wrapper (../dataProvider/withAudit.ts) runs OUTSIDE React — it is
 * the data provider, not a component — so it cannot read the active region from
 * React context. Identity and role come cleanly from the authProvider (token
 * claims), but the *active* region is a UI selection (a GLOBAL admin picks UK or
 * US in the switcher), which lives only in React state. This tiny ambient holder
 * is the one bridge: the `RegionProvider` keeps it in sync, and the wrapper
 * reads it when stamping an audit entry's region context.
 *
 * Deliberately minimal and module-scoped. It is write-from-React,
 * read-from-provider only; nothing else should depend on it.
 */
let currentActiveRegion: string | null = null;

/** Called by RegionProvider whenever the active region changes. */
export const setAmbientActiveRegion = (region: string | null): void => {
  currentActiveRegion = region;
};

/** The active region the audit wrapper stamps onto entries (null if unknown). */
export const getAmbientActiveRegion = (): string | null => currentActiveRegion;
